/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../../common';
import type { MakeOrderLib, MakeOrderLibInterface } from '../../MerkleOrderBookTemplate.sol/MakeOrderLib';

const _abi = [
  {
    inputs: [],
    name: 'InjectOrderNotLast',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidHeadOrder',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidInjectOrder',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidOrder',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidOrderAmount',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidOrderPrice',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidPolicyTokenAmount',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidPrevOrder',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidSigner',
    type: 'error',
  },
  {
    inputs: [
      {
        components: [
          {
            components: [
              {
                components: [
                  {
                    internalType: 'address',
                    name: 'maker',
                    type: 'address',
                  },
                  {
                    internalType: 'bool',
                    name: 'isSell',
                    type: 'bool',
                  },
                  {
                    internalType: 'bool',
                    name: 'isCollateralOrder',
                    type: 'bool',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderPrice',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'index',
                    type: 'uint256',
                  },
                ],
                internalType: 'struct Order',
                name: 'order',
                type: 'tuple',
              },
              {
                internalType: 'bytes32[]',
                name: 'proofs',
                type: 'bytes32[]',
              },
              {
                internalType: 'uint8',
                name: 'bits',
                type: 'uint8',
              },
            ],
            internalType: 'struct OrderWithProofs',
            name: 'newOrder',
            type: 'tuple',
          },
          {
            internalType: 'bytes',
            name: 'newOrderSignature',
            type: 'bytes',
          },
          {
            components: [
              {
                internalType: 'address',
                name: 'maker',
                type: 'address',
              },
              {
                internalType: 'bool',
                name: 'isSell',
                type: 'bool',
              },
              {
                internalType: 'bool',
                name: 'isCollateralOrder',
                type: 'bool',
              },
              {
                internalType: 'uint256',
                name: 'orderAmount',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'orderPrice',
                type: 'uint256',
              },
              {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
              },
            ],
            internalType: 'struct Order',
            name: 'headOrder',
            type: 'tuple',
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: 'address',
                    name: 'maker',
                    type: 'address',
                  },
                  {
                    internalType: 'bool',
                    name: 'isSell',
                    type: 'bool',
                  },
                  {
                    internalType: 'bool',
                    name: 'isCollateralOrder',
                    type: 'bool',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderPrice',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'index',
                    type: 'uint256',
                  },
                ],
                internalType: 'struct Order',
                name: 'order',
                type: 'tuple',
              },
              {
                internalType: 'bytes32[]',
                name: 'proofs',
                type: 'bytes32[]',
              },
              {
                internalType: 'uint8',
                name: 'bits',
                type: 'uint8',
              },
            ],
            internalType: 'struct OrderWithProofs',
            name: 'prevOrder',
            type: 'tuple',
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: 'address',
                    name: 'maker',
                    type: 'address',
                  },
                  {
                    internalType: 'bool',
                    name: 'isSell',
                    type: 'bool',
                  },
                  {
                    internalType: 'bool',
                    name: 'isCollateralOrder',
                    type: 'bool',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderAmount',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'orderPrice',
                    type: 'uint256',
                  },
                  {
                    internalType: 'uint256',
                    name: 'index',
                    type: 'uint256',
                  },
                ],
                internalType: 'struct Order',
                name: 'order',
                type: 'tuple',
              },
              {
                internalType: 'bytes32[]',
                name: 'proofs',
                type: 'bytes32[]',
              },
              {
                internalType: 'uint8',
                name: 'bits',
                type: 'uint8',
              },
            ],
            internalType: 'struct OrderWithProofs',
            name: 'injectOrder',
            type: 'tuple',
          },
        ],
        internalType: 'struct MakeOrderReq',
        name: 'req',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'bytes32',
            name: 'newOrderDigest',
            type: 'bytes32',
          },
          {
            internalType: 'uint256',
            name: 'headOrderNext',
            type: 'uint256',
          },
          {
            internalType: 'bytes32',
            name: 'headOrderDigest',
            type: 'bytes32',
          },
          {
            internalType: 'uint256',
            name: 'prevOrderNext',
            type: 'uint256',
          },
          {
            internalType: 'bytes32',
            name: 'prevOrderDigest',
            type: 'bytes32',
          },
          {
            internalType: 'uint256',
            name: 'injectOrderNext',
            type: 'uint256',
          },
          {
            internalType: 'bytes32',
            name: 'injectOrderDigest',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'OrdersRoot',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'head',
            type: 'bytes32',
          },
        ],
        internalType: 'struct MakeOrderAppend',
        name: 'append',
        type: 'tuple',
      },
    ],
    name: '_makeOrder',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'newOrderNext',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'headOrderNext',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'prevOrderNext',
            type: 'uint256',
          },
          {
            internalType: 'uint256',
            name: 'injectOrderNext',
            type: 'uint256',
          },
          {
            internalType: 'bytes32',
            name: 'head',
            type: 'bytes32',
          },
          {
            internalType: 'bytes32',
            name: 'ordersRoot',
            type: 'bytes32',
          },
        ],
        internalType: 'struct MakeOrderRes',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
];

const _bytecode =
  '0x6116aa61003a600b82828239805160001a60731461002d57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600436106100355760003560e01c80632d1c04941461003a575b600080fd5b61004d61004836600461132d565b6100a2565b6040516100999190600060c082019050825182526020830151602083015260408301516040830152606083015160608301526080830151608083015260a083015160a083015292915050565b60405180910390f35b6040805160c081018252600080825260208201819052918101829052606081018290526080810182905260a08101919091526100de83806113ad565b60600135610118576040517f93845d6800000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b61012283806113ad565b6080013561015c576040517f92bd4aad00000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b73__$228f495fb21f6bb55c754ccea856a59eef$__63ab529f8d61018085806113ad565b61018e9060c08101906113eb565b61019887806113ad565b6101aa9061010081019060e001611453565b6101b488806113ad565b60000160a0013560008860e001356040518763ffffffff1660e01b81526004016101e3969594939291906114cc565b602060405180830381865af4158015610200573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906102249190611516565b61025a576040517faf61069300000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b60006040518060c001604052806000815260200184602001358152602001846060013581526020018460a00135815260200184610100013581526020018460e0013581525090508380600001906102b191906113ad565b6102bf906020810190611533565b73ffffffffffffffffffffffffffffffffffffffff1661032184356102e76020880188611569565b8080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250610f4a92505050565b73ffffffffffffffffffffffffffffffffffffffff161461036e576040517f815e1d6400000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b61037884806113ad565b6103899060408101906020016115ce565b15610914576101008301356103a45782356080820152610e70565b8260400135836101000135146103e6576040517fd8ba7a3500000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b6103f084806113ad565b6080013560c085013511156104125760e0840135815282356080820152610e70565b60208301356104335761042584806113ad565b60a001356020820152610e70565b60006104436101008601866113ad565b610451906020810190611533565b73ffffffffffffffffffffffffffffffffffffffff1614156106265773__$228f495fb21f6bb55c754ccea856a59eef$__63ab529f8d6104956101208701876113ad565b6104a39060c08101906113eb565b6104b16101208901896113ad565b6104c39061010081019060e001611453565b6104d16101208a018a6113ad565b60000160a001358860c001358960e001356040518763ffffffff1660e01b8152600401610503969594939291906114cc565b602060405180830381865af4158015610520573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906105449190611516565b61057a576040517f1074dae600000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b60a0830135156105b6576040517f33722b5300000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b6105c084806113ad565b608001356105d26101208601866113ad565b60800135111561060e576040517f1074dae600000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b61061884806113ad565b60a001356060820152610e70565b73__$228f495fb21f6bb55c754ccea856a59eef$__63ab529f8d61064e6101208701876113ad565b61065c9060c08101906113eb565b61066a6101208901896113ad565b61067c9061010081019060e001611453565b61068a6101208a018a6113ad565b60000160a001358860c001358960e001356040518763ffffffff1660e01b81526004016106bc969594939291906114cc565b602060405180830381865af41580156106d9573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906106fd9190611516565b610733576040517f1074dae600000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b73__$228f495fb21f6bb55c754ccea856a59eef$__63ab529f8d61075b6101008701876113ad565b6107699060c08101906113eb565b6107776101008901896113ad565b6107899061010081019060e001611453565b6107976101008a018a6113ad565b60000160a0013588608001358960e001356040518763ffffffff1660e01b81526004016107c9969594939291906114cc565b602060405180830381865af41580156107e6573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061080a9190611516565b610840576040517fda9d3eba00000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b61084a84806113ad565b6080013561085c6101208601866113ad565b6080013511610897576040517f1074dae600000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b6108a56101208501856113ad565b60000160a001358360600135146108e8576040517fda9d3eba00000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b6108f284806113ad565b60a0013560408201526109096101208501856113ad565b60a001358152610e70565b61010083013561092a5782356080820152610e70565b82604001358361010001351461096c576040517fd8ba7a3500000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b61097684806113ad565b6080013560c085013510156109985760e0840135815282356080820152610e70565b60208301356109ab5761042584806113ad565b60006109bb6101008601866113ad565b6109c9906020810190611533565b73ffffffffffffffffffffffffffffffffffffffff161415610b865773__$228f495fb21f6bb55c754ccea856a59eef$__63ab529f8d610a0d6101208701876113ad565b610a1b9060c08101906113eb565b610a296101208901896113ad565b610a3b9061010081019060e001611453565b610a496101208a018a6113ad565b60000160a001358860c001358960e001356040518763ffffffff1660e01b8152600401610a7b969594939291906114cc565b602060405180830381865af4158015610a98573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610abc9190611516565b610af2576040517f1074dae600000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b60a083013515610b2e576040517f33722b5300000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b610b3884806113ad565b60800135610b4a6101208601866113ad565b60800135101561060e576040517f1074dae600000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b73__$228f495fb21f6bb55c754ccea856a59eef$__63ab529f8d610bae6101208701876113ad565b610bbc9060c08101906113eb565b610bca6101208901896113ad565b610bdc9061010081019060e001611453565b610bea6101208a018a6113ad565b60000160a001358860c001358960e001356040518763ffffffff1660e01b8152600401610c1c969594939291906114cc565b602060405180830381865af4158015610c39573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610c5d9190611516565b610c93576040517f1074dae600000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b73__$228f495fb21f6bb55c754ccea856a59eef$__63ab529f8d610cbb6101008701876113ad565b610cc99060c08101906113eb565b610cd76101008901896113ad565b610ce99061010081019060e001611453565b610cf76101008a018a6113ad565b60000160a0013588608001358960e001356040518763ffffffff1660e01b8152600401610d29969594939291906114cc565b602060405180830381865af4158015610d46573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d6a9190611516565b610da0576040517fda9d3eba00000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b610daa84806113ad565b60800135610dbc6101208601866113ad565b6080013510610df7576040517f1074dae600000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b610e056101208501856113ad565b60000160a00135836060013514610e48576040517fda9d3eba00000000000000000000000000000000000000000000000000000000815260040160405180910390fd5b610e5284806113ad565b60a001356040820152610e696101208501856113ad565b60a0013581525b73__$228f495fb21f6bb55c754ccea856a59eef$__639912fa77610e9486806113ad565b610ea29060c08101906113eb565b610eac88806113ad565b610ebe9061010081019060e001611453565b610ec889806113ad565b60000160a00135886000013560008a60e001356040518863ffffffff1660e01b8152600401610efd97969594939291906115eb565b602060405180830381865af4158015610f1a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f3e919061162c565b60a08201529392505050565b6000806000610f598585610f6e565b91509150610f6681610fb4565b509392505050565b600080825160411415610fa55760208301516040840151606085015160001a610f9987828585611215565b94509450505050610fad565b506000905060025b9250929050565b6000816004811115610fc857610fc8611645565b1415610fd15750565b6001816004811115610fe557610fe5611645565b1415611052576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601860248201527f45434453413a20696e76616c6964207369676e6174757265000000000000000060448201526064015b60405180910390fd5b600281600481111561106657611066611645565b14156110ce576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152601f60248201527f45434453413a20696e76616c6964207369676e6174757265206c656e677468006044820152606401611049565b60038160048111156110e2576110e2611645565b1415611170576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602260248201527f45434453413a20696e76616c6964207369676e6174757265202773272076616c60448201527f75650000000000000000000000000000000000000000000000000000000000006064820152608401611049565b600481600481111561118457611184611645565b1415611212576040517f08c379a000000000000000000000000000000000000000000000000000000000815260206004820152602260248201527f45434453413a20696e76616c6964207369676e6174757265202776272076616c60448201527f75650000000000000000000000000000000000000000000000000000000000006064820152608401611049565b50565b6000807f7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a083111561124c5750600090506003611324565b8460ff16601b1415801561126457508460ff16601c14155b156112755750600090506004611324565b6040805160008082526020820180845289905260ff881692820192909252606081018690526080810185905260019060a0016020604051602081039080840390855afa1580156112c9573d6000803e3d6000fd5b50506040517fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0015191505073ffffffffffffffffffffffffffffffffffffffff811661131d57600060019250925050611324565b9150600090505b94509492505050565b6000808284036101408082121561134357600080fd5b843567ffffffffffffffff81111561135a57600080fd5b850180870382131561136b57600080fd5b9350506101207fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe08201121561139f57600080fd5b506020830190509250929050565b600082357fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff018336030181126113e157600080fd5b9190910192915050565b60008083357fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe184360301811261142057600080fd5b83018035915067ffffffffffffffff82111561143b57600080fd5b6020019150600581901b3603821315610fad57600080fd5b60006020828403121561146557600080fd5b813560ff8116811461147657600080fd5b9392505050565b81835260007f07ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff8311156114af57600080fd5b8260051b8083602087013760009401602001938452509192915050565b60a0815260006114e060a08301888a61147d565b905060ff86166020830152846040830152836060830152826080830152979650505050505050565b801515811461121257600080fd5b60006020828403121561152857600080fd5b815161147681611508565b60006020828403121561154557600080fd5b813573ffffffffffffffffffffffffffffffffffffffff8116811461147657600080fd5b60008083357fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe184360301811261159e57600080fd5b83018035915067ffffffffffffffff8211156115b957600080fd5b602001915036819003821315610fad57600080fd5b6000602082840312156115e057600080fd5b813561147681611508565b60c0815260006115ff60c08301898b61147d565b60ff9790971660208301525060408101949094526060840192909252608083015260a09091015292915050565b60006020828403121561163e57600080fd5b5051919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052602160045260246000fdfea26469706673582212207e3d6df7235af0af9afd1c60bf08054f5b63191158640b67a1a72ea4ad639f4564736f6c634300080c0033';

type MakeOrderLibConstructorParams =
  | [linkLibraryAddresses: MakeOrderLibLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: MakeOrderLibConstructorParams): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === 'string' ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    '_isInterface' in xs[0]
  );
};

export class MakeOrderLib__factory extends ContractFactory {
  constructor(...args: MakeOrderLibConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(_abi, MakeOrderLib__factory.linkBytecode(linkLibraryAddresses), signer);
    }
    this.contractName = 'MakeOrderLib';
  }

  static linkBytecode(linkLibraryAddresses: MakeOrderLibLibraryAddresses): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$228f495fb21f6bb55c754ccea856a59eef\\$__', 'g'),
      linkLibraryAddresses['contracts/imports/SMT.sol:SMT'].replace(/^0x/, '').toLowerCase()
    );

    return linkedBytecode;
  }

  override deploy(overrides?: Overrides & { from?: PromiseOrValue<string> }): Promise<MakeOrderLib> {
    return super.deploy(overrides || {}) as Promise<MakeOrderLib>;
  }
  override getDeployTransaction(overrides?: Overrides & { from?: PromiseOrValue<string> }): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): MakeOrderLib {
    return super.attach(address) as MakeOrderLib;
  }
  override connect(signer: Signer): MakeOrderLib__factory {
    return super.connect(signer) as MakeOrderLib__factory;
  }
  static readonly contractName: 'MakeOrderLib';

  public readonly contractName: 'MakeOrderLib';

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MakeOrderLibInterface {
    return new utils.Interface(_abi) as MakeOrderLibInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): MakeOrderLib {
    return new Contract(address, _abi, signerOrProvider) as MakeOrderLib;
  }
}

export interface MakeOrderLibLibraryAddresses {
  ['contracts/imports/SMT.sol:SMT']: string;
}
